/**
 *
 * Asynchronously loads the component for ProfilePreview
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
